import styled from 'styled-components';

/**
 * @deprecated The shef-web design system is being retired. web-common has no
 *   counterpart yet — see the migration ticket before adding a new call site.
 * @see https://app.asana.com/0/0/1218340650878851
 */
export const Truncate = styled.div<{ lines: number }>`
  > * {
    display: -webkit-box;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: ${(props) => props.lines};
    -webkit-box-orient: vertical;
  }
`;
